import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/poppins/600.css"; // Optional: Semi-bold
import "@fontsource/poppins/700.css"; // Optional: Bold
import Box from "@mui/material/Box";
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.min.css";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import WeAreAtDiscordImg from "./assets/img/join.png";
import BgImg2 from "./assets/img/special-back.jpg";
import BgImage from "./assets/img/subheader-back.jpg";
import Footer from "./components/common/footer";
import ResponsiveAppBar from "./components/common/new-nav-bar";
import DiscordSections from "./components/discord-section-home/DiscordSections";
import FeatureSections from "./components/feature-section/FeatureSections";
import ChangePassForm from "./components/pages/change-pass";
import Downloads from "./components/pages/downloads";
import EventsPage from "./components/pages/events-page";
import { FinderPage } from "./components/pages/finder-page";
import ForgotPassword from "./components/pages/forgot-password";
import Home from "./components/pages/home";
import LoginPage from "./components/pages/login-page";
import Logout from "./components/pages/logout";
import { MarketPlacePage } from "./components/pages/marketplace";
import { PlayerProfile } from "./components/pages/player-profile";
import UserProfile from "./components/pages/profile";
import RankingsPage from "./components/pages/ranks";
import RegisterPage from "./components/pages/register-page";
import ResetPassword from "./components/pages/reset-password";
import { ServerNewsPage } from "./components/pages/server-news-page";
import "./fonts.css";
import AuthService from "./services/authService";
import { useInterceptor } from "./services/axios-interceptors";

const App = () => {
  useInterceptor();

  const ProtectedRouteLoggedIn = ({ children }) => {
    if (!AuthService.isUserLoggedIn()) {
      return <Navigate to="/user/login" replace />;
    }
    return children;
  };

  const ProtectedRouteNotLogged = ({ children }) => {
    if (AuthService.isUserLoggedIn()) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  return (
    <div className="App">
      <ToastContainer />
      <ResponsiveAppBar />

      {/* Section 1 - Routes with BgImage */}
      <Box
        sx={{
          backgroundImage: `url('${BgImage}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box className="main" sx={{ flex: 1 }}>
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/ranks" element={<RankingsPage />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/updates" element={<ServerNewsPage />} />
            <Route
              path="/user/login"
              element={
                <ProtectedRouteNotLogged>
                  <LoginPage />
                </ProtectedRouteNotLogged>
              }
            />
            <Route path="/user/logout" element={<Logout />} />
            <Route path="/user/profile" element={<UserProfile />} />
            <Route
              path="/user/change-password"
              element={
                <ProtectedRouteLoggedIn>
                  <ChangePassForm />
                </ProtectedRouteLoggedIn>
              }
            />
            <Route path="/recoverpassword" element={<ResetPassword />} />
            <Route path="/user/register" element={<RegisterPage />} />
            <Route path="/finder" element={<FinderPage />} />
            <Route path="/marketplace" element={<MarketPlacePage />} />
            <Route path="/user/forgot-password" element={<ForgotPassword />} />
            <Route path="/schedules" element={<EventsPage />} />
            <Route path="/player-profile/:name" element={<PlayerProfile />} />
          </Routes>
        </Box>
      </Box>

      {/* Section 2 - Special Background */}
      <Box
        sx={{
          backgroundImage: `url('${BgImg2}')`,
          backgroundSize: "cover",
          backgroundPosition: "cover",
          backgroundRepeat: "no-repeat",
          width: "100%",
          minHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FeatureSections />
      </Box>

      {/* Section 3 - Special Background In discord */}
      <Box
        sx={{
          backgroundImage: `url('${WeAreAtDiscordImg}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <DiscordSections />
      </Box>

      {/* Section 4 - Footer with Background */}
      <Footer />
    </div>
  );
};

export default App;
